<template>
  <van-popup
    v-model="showPopup"
    :close-on-click-overlay="false"
    class="popup ljb--base-padding">
    <img
      src="https://cdn.51ljb.cn/ljb-pa_check.png"
      class="pop-img">
    <slot/>
  </van-popup>
</template>

<script>
import Vue from 'vue'
import {Popup} from 'vant'

Vue.use(Popup)
export default {
  name: 'PopupToast',
  props: {
    showPopup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPop: true
    }
  },
  methods: {
    goDetail () {
      this.$emit('goDetail')
    },
    goHome () {
      this.$emit('goHome')
    }
  }
}
</script>

<style lang="scss" scoped>
  .popup{
    border-radius: 4px;
    background: #fff;
    width: 280px;
    margin: 0 auto;
    padding: 25px 0;
    text-align: center;
    .title{
      font-size: 18px;
      color: $base-color;
    }
    .pop-img{
      width: 80px;
      height: 80px;
    }
    /*p{*/
      /*margin-top:5px;*/
    /*}*/
    /*.btn{*/
      /*justify-content: space-between;*/
      /*margin-top: 25px;*/
      /*a{*/
        /*width: 46%;*/
        /*line-height: 45px;*/
      /*}*/
    /*}*/
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/PopupToast.vue